import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toggleStepsList, toggleResponsesList, selectResponse, selectStep, selectMode, selectFeature } from '../actions/commonActions'
import { _BASIC_TRANSACTIONS } from '../actions/types'
import Indicator from '../components/common/Indicator'
import StepsList from '../components/common/StepsList'
import ResponseList from '../components/common/ResponseList'
import { FEATURES } from '../constants/common/Features'
import responses from '../constants/transactions/responses'
import Response from '../components/common/Response'
import Purchase from '../components/transactions/steps/Purchase'
import PreAuth from '../components/transactions/steps/PreAuth'
import PreAuthCompletion from '../components/transactions/steps/PreAuthCompletion'
import ForcePost from '../components/transactions/steps/ForcePost'
import PurchaseCorrection from '../components/transactions/steps/PurchaseCorrection'
import Refund from '../components/transactions/steps/Refund'
import BatchClose from '../components/transactions/steps/BatchClose'
import IndependentRefund from '../components/transactions/steps/IndependentRefund'
import CardVerification from '../components/transactions/steps/CardVerification'
import OpenTotals from '../components/transactions/steps/OpenTotals'
import Configuration from '../components/transactions/steps/Configuration'
import StepsMenu from '../components/common/StepsMenu'
import Footer from '../components/common/Footer'

var isIE = /*@cc_on!@*/false || !!document.documentMode;
var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

const scrollToRef = (ref) => {ref.current.scrollIntoView({behavior: "smooth"})}


export class TransactionsPage extends Component {
    state = {
        ref1: React.createRef(),
        ref2: React.createRef(),
        ref3: React.createRef(),
        ref4: React.createRef(),
        ref5: React.createRef(),
        ref6: React.createRef(),
        ref7: React.createRef(),
        ref8: React.createRef(),
        ref9: React.createRef(),
        ref10: React.createRef(),
    }

    componentDidMount() {
        if(this.props.mode === "integration_guide")
            this.scrollIntoStep(this.props.selectedStep);

        document.title = 'Basic Transactions | Moneris Developers';
    }

    componentDidUpdate(prevProps) {
        const { selectedStep, mode } = this.props;

        if(mode !== prevProps.mode && mode === 'integration_guide') {
            this.scrollIntoStep(selectedStep)
        }
    }

    isInViewport(elem) {
        if (!elem) return false;
        const offset = window.pageYOffset;
        const top = elem.getBoundingClientRect().top;
        return (top + offset) >= 0 && (top - offset) <= window.innerHeight;
    }

    justLeft(elem) {
        if (!elem) return false;
        const offset = window.pageYOffset;
        const top = elem.getBoundingClientRect().top;
        const diff = (top - offset) - window.innerHeight;
        return (top + offset) >= 0 && diff > 0 && diff < 100;
    }

    handleScrolling() {
        const { ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10 } = this.state
        const { selectStep } = this.props

        if(this.isInViewport(ref1.current) || this.justLeft(ref2.current)) {
            selectStep({stepId: 1, featureId: _BASIC_TRANSACTIONS})
            return
        }
        if(this.isInViewport(ref2.current) || this.justLeft(ref3.current)) {
            selectStep({stepId: 2, featureId: _BASIC_TRANSACTIONS})
            return
        }
        if(this.isInViewport(ref3.current) || this.justLeft(ref4.current)) {
            selectStep({stepId: 3, featureId: _BASIC_TRANSACTIONS})
            return
        }
        if(this.isInViewport(ref4.current) || this.justLeft(ref5.current)) {
            selectStep({stepId: 4, featureId: _BASIC_TRANSACTIONS})
            return
        }
        if(this.isInViewport(ref5.current) || this.justLeft(ref6.current)) {
            selectStep({stepId: 5, featureId: _BASIC_TRANSACTIONS})
            return
        }
        if(this.isInViewport(ref6.current) || this.justLeft(ref7.current)) {
            selectStep({stepId: 6, featureId: _BASIC_TRANSACTIONS})
            return
        }
        if(this.isInViewport(ref7.current) || this.justLeft(ref8.current)) {
            selectStep({stepId: 7, featureId: _BASIC_TRANSACTIONS})
            return
        }
        if(this.isInViewport(ref8.current) || this.justLeft(ref9.current)) {
            selectStep({stepId: 8, featureId: _BASIC_TRANSACTIONS})
            return
        }
        if(this.isInViewport(ref9.current) || this.justLeft(ref10.current)) {
            selectStep({stepId: 9, featureId: _BASIC_TRANSACTIONS})
            return
        }
        if(this.isInViewport(ref10.current)) {
            selectStep({stepId: 10, featureId: _BASIC_TRANSACTIONS})
            return
        }
    }

    scrollIntoStep(stepId) {
        switch(stepId) {
            case 1:
                scrollToRef(this.state.ref1)
                break
            case 2:
                scrollToRef(this.state.ref2)
                break
            case 3:
                scrollToRef(this.state.ref3)
                break
            case 4:
                scrollToRef(this.state.ref4)
                break
            case 5:
                scrollToRef(this.state.ref5)
                break
            case 6:
                scrollToRef(this.state.ref6)
                break
            case 7:
                scrollToRef(this.state.ref7)
                break
            case 8:
                scrollToRef(this.state.ref8)
                break
            case 9:
                scrollToRef(this.state.ref9)
                break
            case 10:
                scrollToRef(this.state.ref10)
                break
            default:
                scrollToRef(this.state.ref1)
                break
        }
    }

    renderStepsContent() {
        if(this.props.mode === 'integration_guide') {
            return (
                <div className='pageContents'>
                    <div className='stepsContainer'>
                        <span ref={this.state.ref1}></span>
                        <Purchase />
                        <span ref={this.state.ref2}></span>
                        <PreAuth />
                        <span ref={this.state.ref3}></span>
                        <PreAuthCompletion />
                        <span ref={this.state.ref4}></span>
                        <ForcePost />
                        <span ref={this.state.ref5}></span>
                        <PurchaseCorrection />
                        <span ref={this.state.ref6}></span>
                        <Refund />
                        <span ref={this.state.ref7}></span>
                        <IndependentRefund />
                        <span ref={this.state.ref8}></span>
                        <CardVerification />
                        <span ref={this.state.ref9}></span>
                        <BatchClose />
                        <span ref={this.state.ref10}></span>
                        <OpenTotals />
                    </div>
                    <Footer />
                </div>
            );
        }
        else {
            switch(this.props.selectedStep) {
                case 1:
                    return <Purchase />
                case 2:
                    return <PreAuth />
                case 3:
                    return <PreAuthCompletion />
                case 4:
                    return <ForcePost />
                case 5:
                    return <PurchaseCorrection />
                case 6:
                    return <Refund />
                case 7:
                    return <IndependentRefund />
                case 8:
                    return <CardVerification />
                case 9:
                    return <BatchClose />
                case 10:
                    return <OpenTotals />
                default:
                    return null
            }
        }
    }


    renderResponseContent() {
        const { selectedResponse, loading, purchaseResponse, preAuthResponse, preAuthCompResponse, 
                forcePostResponse, purchaseCorrectionResponse, refundResponse, independentRefundResponse,
                cardVerificationResponse, batchCloseResponse, openTotalsResponse} = this.props;

        switch(selectedResponse) {
            case 1:
                return <Response title="Actual Purchase Output" output={purchaseResponse} loading={loading}/>
            case 2:
                return <Response title="Actual Pre-Authorization Output" output={preAuthResponse} loading={loading} />
            case 3:
                return <Response title="Actual Pre-Authorization Completion Output" output={preAuthCompResponse} loading={loading} />
            case 4:
                return <Response title="Actual Force Post Output" output={forcePostResponse} loading={loading} />
            case 5:
                return <Response title="Actual Purchase Correction Output" output={purchaseCorrectionResponse} loading={loading} />
            case 6:
                return <Response title="Actual Refund Output" output={refundResponse} loading={loading} />
            case 7:
                return <Response title="Actual Independent Refund Output" output={independentRefundResponse} loading={loading} />
            case 8:
                return <Response title="Actual Card Verification Output" output={cardVerificationResponse} loading={loading} />
            case 9:
                return <Response title="Actual Batch Close Output" output={batchCloseResponse} loading={loading} />
            case 10:
                return <Response title="Actual Open Totals Output" output={openTotalsResponse} loading={loading} />
            default:
                return null
        }
    }

    renderNextSteps() {
        const {selectedResponse, prevSuccStep, purchaseSuccess, preAuthSuccess, preAuthCompSuccess, forcePostSuccess, purchaseCorrectionSuccess, independentRefundSuccess, cardVerificationSuccess, batchCloseSuccess, refundSuccess} = this.props;

        if(prevSuccStep === selectedResponse &&  ((selectedResponse === 1 && purchaseSuccess) || (selectedResponse === 3 && preAuthCompSuccess) || (selectedResponse === 4 && forcePostSuccess))) {
            return (
                <div className='sugestedNextSteps'>
                    <h3 style={{marginTop: '0'}}>Suggested Next Steps:</h3>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '1vh'}}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 5, featureId: _BASIC_TRANSACTIONS})}>Purchase Correction</span>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 10, featureId: _BASIC_TRANSACTIONS})}>Open Totals</span>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 9, featureId: _BASIC_TRANSACTIONS})}>Batch Close</span>
                    </div>
                </div>
            );
        }
        
        if(prevSuccStep === selectedResponse && selectedResponse === 2 && preAuthSuccess) {
            return (
                <div className='sugestedNextSteps'>
                    <h3>Suggested Next Steps:</h3>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '1vh'}}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 3, featureId: _BASIC_TRANSACTIONS})}>Pre-Authorization Completion</span>
                    </div>
                </div>
            );
        }

        if(prevSuccStep === selectedResponse && ((selectedResponse === 5 && purchaseCorrectionSuccess) || (selectedResponse === 7 && independentRefundSuccess) || (selectedResponse === 8 && cardVerificationSuccess))) {
            return (
                <div className='sugestedNextSteps'>
                    <h3>Suggested Next Steps:</h3>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '1vh'}}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 10, featureId: _BASIC_TRANSACTIONS})}>Open Totals</span>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 9, featureId: _BASIC_TRANSACTIONS})}>Batch Close</span>
                    </div>
                </div>
            );
        }

        if(prevSuccStep === selectedResponse && batchCloseSuccess && selectedResponse === 9 && (purchaseSuccess || preAuthCompSuccess || forcePostSuccess)) {
            return (
                <div className='sugestedNextSteps'>
                    <h3>Suggested Next Steps:</h3>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '1vh'}}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 6, featureId: _BASIC_TRANSACTIONS})}>Refund</span>
                    </div>
                </div>
            );
        }

        if(!preAuthSuccess && !preAuthCompSuccess && selectedResponse === 3) {
            return (
                <div className='sugestedNextSteps'>
                    <h3>Pre-Requisite Transaction:</h3>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '1vh'}}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 2, featureId: _BASIC_TRANSACTIONS})}>Pre-Authorization</span>
                    </div>
                </div>
            );
        }

        if(!purchaseCorrectionSuccess && !preAuthCompSuccess && !purchaseSuccess && !forcePostSuccess && selectedResponse === 5) {
            return (
                <div className='suggestedNextSteps'>
                    <span>Pre-Requisite Transactions:</span>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '10px'}}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 1, featureId: _BASIC_TRANSACTIONS})}>Purchase</span> or
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 3, featureId: _BASIC_TRANSACTIONS})}>Pre-Authorization Completion</span> or
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 4, featureId: _BASIC_TRANSACTIONS})}>Force Post</span>
                    </div>
                </div>
            );
        }

        if(!refundSuccess && !preAuthCompSuccess && !purchaseSuccess && !forcePostSuccess && selectedResponse === 6) {
            return (
                <div className='sugestedNextSteps'>
                    <h3>Pre-Requisite Transactions:</h3>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '1vh'}}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 1, featureId: _BASIC_TRANSACTIONS})}>Purchase</span> OR
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 3, featureId: _BASIC_TRANSACTIONS})}>Pre-Authorization Completion</span> OR
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 4, featureId: _BASIC_TRANSACTIONS})}>Force Post</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '1vh', marginLeft: '0.5vw'}}>THEN:</div>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '1vh'}}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 9, featureId: _BASIC_TRANSACTIONS})}>Batch Close</span>
                    </div>
                </div>
            );
        }
        
        if(!refundSuccess && !batchCloseSuccess && (preAuthCompSuccess || purchaseSuccess || forcePostSuccess) && selectedResponse === 6) {
            return (
                <div className='sugestedNextSteps'>
                    <h3>Pre-Requisite Transactions:</h3>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '1vh'}}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 9, featureId: _BASIC_TRANSACTIONS})}>Batch Close</span>
                    </div>
                </div>
            );
        }
    }

    renderRightSide() {
        const { selectResponse, toggleResponsesList, isResponsesListOpen, selectedResponse, mode } = this.props;
        if(mode === 'interactive_tool') {
            return (
                    <div className="rightContainer">
                        <ResponseList
                            isOpen={isResponsesListOpen}
                            selection={selectedResponse}
                            responses={responses.filter((response) => this.props.history.includes(response.id))}
                            toggleResponseList={toggleResponsesList}
                            selectResponse={selectResponse}
                            featureId={_BASIC_TRANSACTIONS}
                        />

                        <div className="rightContents">
                            {this.renderResponseContent()}
                            {this.renderNextSteps()}
                        </div>
                    </div>
            );
        }
    }

    renderLeftSide() {
        const { selectedStep, selectStep, toggleStepsList, isStepsListOpen, mode } = this.props;
        const steps = FEATURES.basicTransactionSet.steps;

        if(mode === 'interactive_tool') {
            return (
                <div className='leftContainer'>
                    <StepsList 
                        isOpen={isStepsListOpen}
                        selection={selectedStep} 
                        toggleStepsList={toggleStepsList} 
                        steps={steps}
                        selectStep={selectStep}
                        featureId={_BASIC_TRANSACTIONS}
                    />
                    {this.renderStepsContent()}
                </div>
            );
        }
        else {
            return (
                <div className='documentContainer' onWheel={() => this.handleScrolling()}>
                    <StepsMenu 
                        selectStep={selectStep}
                        selection={selectedStep}
                        steps={steps}
                        featureId={_BASIC_TRANSACTIONS}
                        scrollIntoStep={(stepId) => this.scrollIntoStep(stepId)}
                    />
                    {this.renderStepsContent()}
                </div>
            );
        }
    }

    renderUpArrow() {
        if(this.props.mode === 'integration_guide') {
            if(isIE) {
                return (
                    <div style={{ marginLeft: '42vw', marginTop: '55vh'}} className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                        <span style={{ marginTop: '1vh' }}>&#8679;</span>
                    </div>
                );
            }
            else if(isSafari) {
                return (
                    <div style={{ marginLeft: '45vw', marginTop: '30vh', paddingBottom: '1vh'}} className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                        <span style={{ marginTop: '1vh' }}>&#8679;</span>
                    </div>
                );
            }
            else {
                if(navigator.platform === "Win32") {
                    return (
                        <div className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                            <span>&#129093;</span>
                        </div>
                    );
                }
                else {
                    return (
                        <div className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                            <span>&#8679;</span>
                        </div>
                    );
                }
            }
        }
    }    

    render() {
        const { selectedStep, selectStep } = this.props;

        return (
            <div className="desktop">
                <Indicator 
                    title="Basic Transactions"
                    steps={FEATURES.basicTransactionSet.steps}
                    renderConfig={() => <Configuration />}
                    selection={selectedStep}
                    selectStep={selectStep}
                    isInteractive={() => true}
                    history={this.props.history}
                />
                
                <div className="mainContainer">
                    {this.renderLeftSide()}
                    {this.renderRightSide()}
                    {this.renderUpArrow()}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const selectedStep = state.transactions.stepsList.selection;
    const isStepsListOpen = state.transactions.stepsList.isOpen;
    const selectedResponse = state.transactions.responseList.selection;
    const isResponsesListOpen = state.transactions.responseList.isOpen;

    const { prevSuccStep, loading, purchaseSuccess, preAuthSuccess, 
            preAuthCompSuccess, forcePostSuccess, purchaseCorrectionSuccess, 
            refundSuccess, independentRefundSuccess, cardVerificationSuccess, 
            batchCloseSuccess, openTotalsSuccess} = state.transactions.main;

    const { mode } = state.common.sideNav;

    const { purchaseResponse, preAuthResponse, preAuthCompResponse, forcePostResponse, 
            purchaseCorrectionResponse, refundResponse, independentRefundResponse, 
            cardVerificationResponse, batchCloseResponse, openTotalsResponse, history,
        } = state.transactions.main;

    return {selectedStep, isStepsListOpen, selectedResponse, isResponsesListOpen, 
            prevSuccStep, mode, purchaseResponse, loading, purchaseSuccess, preAuthResponse, 
            preAuthSuccess, preAuthCompSuccess, preAuthCompResponse, forcePostSuccess, forcePostResponse,
            purchaseCorrectionSuccess, purchaseCorrectionResponse, refundSuccess, independentRefundSuccess, 
            cardVerificationSuccess, batchCloseSuccess, openTotalsSuccess, refundResponse, history,
            independentRefundResponse, cardVerificationResponse, batchCloseResponse, openTotalsResponse
        };
}

export default connect(mapStateToProps, {selectStep, selectMode, toggleStepsList, toggleResponsesList, selectResponse, selectFeature})(TransactionsPage);
